import { CONSTANT } from '../../constant/constant';
import { ENDPOINTS } from '../../constant/endpoints';
import { generalHttpPostRequest } from '../../helper/request-helper';
import { cleanLocalStorageByPrefix } from '../../helper/auth-helper';

const loginUrl = CONSTANT.baseUrl + ENDPOINTS.authentication.login;
const logoutUrl = CONSTANT.baseUrl + ENDPOINTS.authentication.logout;

export const actionType = {
    REQUESTED_AUTHENTICATION_DATA: 'REQUESTED_AUTHENTICATION_DATA',
    REJECTED_AUTHENTICATION_DATA: 'REJECTED_AUTHENTICATION_DATA',
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    IS_AUTHENTICATED: 'IS_AUTHENTICATED'
};

export const login = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_AUTHENTICATION_DATA
        });

        return generalHttpPostRequest(loginUrl, null, params)
            .then(response => {
                localStorage.setItem(
                    'MasterLinkUser',
                    JSON.stringify(response.data)
                );
                dispatch({
                    type: actionType.LOGIN,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_AUTHENTICATION_DATA,
                    data: error
                });
            });
    };
};

export const logout = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_AUTHENTICATION_DATA
        });

        return generalHttpPostRequest(logoutUrl)
            .then(response => {
                cleanLocalStorageByPrefix('MasterLinkUser');
                cleanLocalStorageByPrefix('DataTables_MLP');
                dispatch({
                    type: actionType.LOGOUT,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_AUTHENTICATION_DATA,
                    data: error
                });
            });
    };
};

export const isAuthenticated = () => {
    let user = localStorage.getItem('MasterLinkUser');
    if (user) {
        user = JSON.parse(user);
    }
    return dispatch => {
        dispatch({
            type: actionType.IS_AUTHENTICATED,
            payload: user
        });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/authentication/actions.js